export default "__VITE_ASSET__DDygv2xC__"